import React from "react";
import { Box, Typography } from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";

type Props = {
  tabIndex: number;
  partnerStartedJourney: boolean;
  onConfirmDeleteCoApplicant: () => void;
};

export function DocumentsSectionHeader({
  tabIndex,
  partnerStartedJourney,
  onConfirmDeleteCoApplicant,
}: Props) {
  return (
    <Box
      sx={{
        mt: 3,
        mb: 3,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          fontSize: "18px",
          color: "#1F2233",
        }}
      >
        Please upload pending documents
      </Typography>

      {tabIndex > 1 && !partnerStartedJourney && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            cursor: "pointer",
          }}
          onClick={onConfirmDeleteCoApplicant}
        >
          <DeleteOutline sx={{ fontSize: "20px", color: "rgb(255, 76, 81)" }} />
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "16px",
              color: "rgb(255, 76, 81)",
            }}
          >
            Remove
          </Typography>
        </Box>
      )}
    </Box>
  );
}

